import { ChangeDetectorRef, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { AuthGuard } from "./core/auth/auth.guard";
import { SwUpdate, SwPush } from "@angular/service-worker";
import { appVersion } from "./core/constants/urls";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  version = appVersion;
  activeSession = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser")).activeSession
    : false;
  constructor(
    public translate: TranslateService,
    public router: Router,
    private swupdate: SwUpdate,
    private swPush: SwPush
  ) {
    // checks if update available
    this.swupdate.available.subscribe((event: any) => {
      // reload / refresh the browser
      this.swupdate.activateUpdate().then(() => document.location.reload());
    });
  }

  ngOnInit() {
    this.swPush.messages.subscribe((message) => {});
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    sessionStorage.setItem("currentLang", lang);
  }
}
